import { Link } from "react-router-dom";
import { useAuth } from "../../features/auth/hooks/useAuth";

export default function Header({ toggleSidebar }) {
  const { logout } = useAuth();

  function handleLogout() { logout(); }

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet" />

      <header>
        <nav>
          <div className="logoNav">
            <img src="/LOGO.png" alt="logo" width="32px" height="auto" />
            <span style={{
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 800,
              fontSize: "1.2rem",
              letterSpacing: "2px",
              lineHeight: 1,
              userSelect: "none",
              textTransform: "uppercase",
            }}>
              <span style={{ color: "#f97316" }}>COR</span>
              <span style={{ color: "#e5ecf5" }}>VIAN</span>
            </span>
          </div>

          <div className="navIcons">
            {/* Hamburger — solo visible en mobile */}
            <button
              className="nav-icon-btn nav-hamburger-btn"
              title="Menú"
              aria-label="Abrir menú"
              onClick={toggleSidebar}
            >
              <i className="fa-solid fa-bars" />
            </button>
            <Link to="/settings" className="nav-icon-btn" title="Configuración">
              <i className="fa-solid fa-gear" />
            </Link>
            <button className="nav-icon-btn nav-logout-btn"
              title="Cerrar sesión" aria-label="Cerrar sesión"
              onClick={handleLogout}>
              <i className="fa-solid fa-right-from-bracket" />
            </button>
            <button className="nav-bell-btn" title="Notificaciones (próximamente)" aria-label="Notificaciones">
              <i className="fa-solid fa-bell" />
            </button>
          </div>
        </nav>
      </header>
    </>
  );
}
